import React from 'react';
import Button from 'react-bootstrap/esm/Button';
import Card from 'react-bootstrap/esm/Card';
import RedirectPagamentoService from './redirectPagamentoService';
import polliceVerde from './pollice_verde.png';
import polliceRosso from './pollice_rosso.png';
import LoadSpinner from '../../../common/spinner/loadSpinner';
import logoCompany from '../../../assets/img/logo_APAM.svg'


export default class EsitoPagamento extends React.Component{
    constructor(props){
        super(props)
        this.state ={
            load: false,
            dettagliPagamento:{
                esito:false,
                messaggio:"",
                numeroPagamento:"",
                numeroSanzione:"",
                importo:"",
                file:""

            }
        }

        this.redirectPagamentoService = new RedirectPagamentoService();
    }

    componentDidMount(){
        this.getDettagli()


    }

    getDettagli(){
        const params = new URLSearchParams(this.props.location.search);
        const param = params.get("param");
        if(param === null){
            window.location.href = "#/ricercasanzione"
        }else{
            this.redirectPagamentoService.sendEsitoPagamento(param.split("?")[0],(result)=>{
                this.setState({dettagliPagamento: result})
                this.setState({load:true})
            },)
        }
    }

    ritornaAllaPaginaDiRicerca(){
        window.location.href = "#/ricercasanzione"
    }

    downloadRicevuta(){
        const element = document.createElement('a')
        element.href = `data:application/pdf;base64,${this.state.dettagliPagamento.file}`
        element.download = `attestato_pagamento_${this.state.dettagliPagamento.numeroSanzione}.pdf`
        document.body.appendChild(element)
        element.click()
    }

    render(){
        return (
            !this.state.load 
            ? <LoadSpinner/>
            :<div>
                <div className='container-fluid flex-column d-flex justify-content-center align-item-center ps-5 pe-5 pt-3 pb-5'>
                <div className='row d-flex flex-md-row flex-column-reverse justify-content-between justify-content-md-center align-items-center text-center text-lg-start pl-lg-5'>
                    <img className='col-12' src={logoCompany} style={{height:"120px", width:"120px"}} alt='logo APAM'/>
                </div>
                <Card className="text-center w-75 align-self-center">
                    <Card.Header>{this.state.dettagliPagamento.file !== null ? "Pagamento avvenuto con successo" : "Pagamento non trovato o in errore"}</Card.Header>
                    <Card.Body className='d-flex flex-column justify-content-center align-items-center gap-3'>
                        <Card.Title></Card.Title>
                        {(this.state.dettagliPagamento.file !== null && this.state.dettagliPagamento.file !== "") && <Card.Img style={{width:"5.8rem"}} src={polliceVerde}></Card.Img>}
                        {(this.state.dettagliPagamento.file === null || this.state.dettagliPagamento.file === "" )&&  <Card.Img style={{width:"5.8rem"}} src={polliceRosso}></Card.Img>}
                        <Button variant="primary" onClick={()=>this.ritornaAllaPaginaDiRicerca()}>Ritorna alla pagina di ricerca</Button>
                    </Card.Body>
                    <Card.Footer className="text-muted">
                        {this.state.dettagliPagamento.esito && this.state.dettagliPagamento.file !== ""  && <Button variant='primary' onClick={()=>this.downloadRicevuta()} >Scarica Attestato di Pagamento</Button>}
                    </Card.Footer>
                </Card>
                </div>
                <p className='text-center' style={{fontSize:"0.7rem"}}> APAM ESERCIZIO S.P.A. - Sede legale: Via dei Toscani, 3/c, 46100 Mantova, C.P. 239 Mantova Centro - tel: 0376 2301 - fax: 0376 230330</p>
                <p className='text-center' style={{fontSize:"0.7rem"}}> P.IVA/C.F. e iscriz. Registro Imprese di Mn n. 02004750200 - numero REA: MN-215834 - apam@legalmail.it</p>
            </div>
        )
    }
}
